/** The value a map holds at `key`, made by `make` and stored there the first time it is asked for. */
export function getOrSet<K, V>(
  map: { has(key: K): boolean; get(key: K): V | undefined; set(key: K, value: V): unknown },
  key: K,
  make: () => V,
): V {
  if (map.has(key)) return map.get(key)!;
  const value = make();
  map.set(key, value);
  return value;
}
